import { alphaSorter, isEqual } from 'vet-bones/utils';

import { Model } from 'src/containers/ProjectDiagram/types/model';
import { addSensitivePropertyGroup } from 'src/containers/ProjectDiagram/utils/sensitivePropertyGroups/addSensitivePropertyGroup';
import { Database } from 'src/store/state/databases';

export const addSensitivePropertyGroupsFromDatabase =
  (database: Database) => (model: Model) => {
    if (!database || !database.sensitivePropertyGroups) {
      return;
    }

    const { sensitivePropertyGroups } = database;
    const { attributesByIri, sensitivePropertyGroupsByName } = model.modelData;
    const existingAttributeIris = new Set(Object.keys(attributesByIri));
    const usedSpgNames = new Set(Object.keys(sensitivePropertyGroupsByName));

    const getUniqueSpgName = (baseName: string) => {
      if (!usedSpgNames.has(baseName)) {
        return baseName;
      }

      let numberForName = 1;
      let numberedName = `${baseName}_${numberForName}`;
      while (usedSpgNames.has(numberedName)) {
        numberForName += 1;
        numberedName = `${baseName}_${numberForName}`;
      }
      return numberedName;
    };

    Object.entries(sensitivePropertyGroups).forEach(
      ([groupName, attributeIris]) => {
        const attributesForSpg: string[] = [];

        attributeIris.sort(alphaSorter).forEach((attributeIri) => {
          if (existingAttributeIris.has(attributeIri)) {
            attributesForSpg.push(attributeIri);
          }
        });

        if (attributesForSpg.length) {
          const existingIris = sensitivePropertyGroupsByName[groupName];
          // If the base name is taken AND has the same attributes, skip it
          if (
            existingIris &&
            isEqual([...existingIris].sort(alphaSorter), attributesForSpg)
          ) {
            return;
          }

          const uniqueSpgName = getUniqueSpgName(groupName);
          addSensitivePropertyGroup(uniqueSpgName, attributesForSpg)(model);
        }
      }
    );
  };
